import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';
import {ShortVoter} from '../../models/ShortVoter';

@Component({
  selector: 'assessors-list-popup',
  templateUrl: './assessors-list-popup.component.html',
  styleUrls: ['./assessors-list-popup.component.less', '../../shared/common.less']
})
export class AssessorsListPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() relaunchAssessors = new EventEmitter<void>();
  @Output() relaunchSingleAssessorEvent = new EventEmitter<string>();
  @Output() updateAssessorEvent = new EventEmitter<string>();
  @Input() canResendAssessors: boolean = false;
  @Input() remainingAssessorTime: string = '';
  @Input() mails: Array<ShortVoter>;
  @Input() isAssessors = false;
  @Input() assessors = []
  @Input() allAssessors = []

  // Tableaux séparés pour les noms et emails
  names: string[] = [];
  emails: string[] = [];
  assessorStatusMap: Map<string, boolean> = new Map();

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  ngOnInit() {
    const mailsEmailSet = new Set<string>();
    this.mails.forEach(voter => {
      const emailOnly = voter.email.includes(' - ') ? voter.email.split(' - ')[1].trim() : voter.email.trim();
      mailsEmailSet.add(emailOnly);
    });
    this.allAssessors.forEach((voterString: string) => {
      const parts = voterString.split(' - ');
      
      if (parts.length === 2) {
        const name = parts[0].trim();
        const email = parts[1].trim();
        
        this.names.push(name);
        this.emails.push(email);
        
        const isValidated = !mailsEmailSet.has(email);
        console.log(`Email: ${email}, Dans mails: ${mailsEmailSet.has(email)}, Validé: ${isValidated}`);
        this.assessorStatusMap.set(email, isValidated);
      }
    });
  }

}
